import { useState } from 'react';
import useModal from 'hooks/useModal';
import styles from 'styles/pages/modal/ViewImage.module.scss';
import { ReactComponent as CloseIcon } from '../../assets/icons/close_gray.svg';

type TProps = {
  path: string;
  errorMsg?: string;
};

const ViewImage = ({ path, errorMsg }: TProps) => {
  const [loaded, setLoaded] = useState(false);
  const [imgStyle, setImgStyle] = useState({} as React.CSSProperties);
  const { openModal, closeModal } = useModal();

  const handleLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = event.target as HTMLImageElement;
    const ratio = img.naturalWidth / img.naturalHeight;
    const windowRatio = window.innerWidth / window.innerHeight;

    if (
      img.naturalWidth > window.innerWidth ||
      img.naturalHeight > window.innerHeight
    ) {
      if (ratio > windowRatio) {
        setImgStyle({
          width: '80vw',
          height: 'auto',
          minHeight: '96px',
        });
      } else {
        setImgStyle({
          width: 'auto',
          height: '80vh',
          minWidth: '96px',
        });
      }
    } else {
      setImgStyle({
        width: 'auto',
        height: 'auto',
        minWidth: '96px',
        minHeight: '96px',
      });
    }
    setLoaded(true);
  };

  const handleError = () => {
    closeModal();
    openModal({
      text: errorMsg || '이미지 로드에 실패했습니다.',
    });
  };

  return (
    <div className={styles.wrapper}>
      <img
        src={path}
        alt="view"
        className={styles.image}
        style={imgStyle}
        onLoad={handleLoad}
        onError={handleError}
      />
      {loaded && (
        <button type="button" className={styles.close} onClick={closeModal}>
          <CloseIcon alt="close" onClick={closeModal} />
        </button>
      )}
    </div>
  );
};

export default ViewImage;
